import React from 'react'

interface Activity {
  type: string
  title: string
  description: string
  timestamp: string
}

interface ActivityFeedProps {
  activities: Activity[]
}

const ActivityFeed: React.FC<ActivityFeedProps> = ({ activities }) => {
  return (
    <div className="space-y-3">
      {activities.length === 0 ? (
        <p className="text-gray-500 text-sm">No recent activities</p>
      ) : (
        activities.map((activity, index) => (
          <div key={index} className="flex items-start space-x-3">
            <div className="flex-shrink-0">
              <div className="w-2 h-2 bg-blue-500 rounded-full mt-2"></div>
            </div>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium text-gray-900">{activity.title}</p>
              <p className="text-sm text-gray-600">{activity.description}</p>
              <p className="text-xs text-gray-400">{activity.timestamp}</p>
            </div>
          </div>
        ))
      )}
    </div>
  )
}

export default ActivityFeed 